import type { ApprovalGateKind } from './projections.ts';

/** The exact closed Gate-kind set the Approvals type filter exposes. */
export const APPROVAL_GATE_KINDS = [
  'task_draft',
  'task_start',
  'metric_activation',
  'schedule_activation',
  'metric_value_authoritative',
  'hubspot_write',
] as const satisfies readonly ApprovalGateKind[];

/** Shared human labels for gate rows and gate-kind filters. */
export const APPROVAL_GATE_LABELS: Readonly<Record<ApprovalGateKind, string>> = {
  task_draft: 'Task draft',
  task_start: 'Task start',
  metric_activation: 'Activate KPI',
  schedule_activation: 'Activate schedule',
  metric_value_authoritative: 'Confirm value',
  hubspot_write: 'HubSpot update',
};
